import { Component, OnInit } from '@angular/core';

import { environment } from '@environments/environment';
import { gitVersion } from '@environments/git-version';

// import { version } from 'package.json';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit {
  version = '';
  commit = '';
  branch = '';
  env = '';
  currentYear: number;
  showBackToTop = false;

  constructor() {}

  /**
   * OnInit - set current code version, commit id, and current year as a hidden text in the footer
   */
  ngOnInit(): void {
    // this.version = version;
    this.env = environment.name;
    this.commit = gitVersion.commit;
    this.branch = gitVersion.branch;

    this.currentYear = new Date().getFullYear();
    this.showBackToTop = environment.beyond.featureFlags.showBackToTop;
  }
}
